import Head from 'next/head';

import MainLayout from '../layouts/MainLayout';
import {FeedbackPageComponent} from '@components/FeedbackPageComponent';

import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {useTranslation} from 'next-i18next';
import {GetStaticPropsContext} from 'next';

export default function Palaute() {
  const {t} = useTranslation('feedback');
  return (
    <MainLayout>
      <Head>
        <title>{t<string>('page_title')}</title>
      </Head>
      <FeedbackPageComponent />
    </MainLayout>
  );
}

export async function getStaticProps({locale}: GetStaticPropsContext) {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ['common', 'feedback'])),
    },
  };
}
